import { render, staticRenderFns } from "./PromotionPopup.vue?vue&type=template&id=76c54e3e"
import script from "./PromotionPopup.vue?vue&type=script&lang=ts"
export * from "./PromotionPopup.vue?vue&type=script&lang=ts"
import style0 from "./PromotionPopup.vue?vue&type=style&index=0&id=76c54e3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QBtn,QSpace,QIcon});qInstall(component, 'directives', {ClosePopup});
